import { onActivated, onBeforeUnmount, onDeactivated } from 'vue';

/**
 * Registers the calling input with the surrounding `NxLoadingWrapper` for as long
 * as it is mounted and active, so the wrapper hides its own fallback icon only
 * while an input paints the status. A `<KeepAlive>` (e.g. an inactive `TabPanel`)
 * deactivates the input without unmounting it, so it unregisters on deactivation
 * and registers again on activation.
 */
export function useLoadingStateRegistration(loadingState: { register: () => () => void } | null) {
  if (!loadingState) return;

  let unregister: (() => void) | undefined = loadingState.register();
  const leave = () => {
    unregister?.();
    unregister = undefined;
  };

  // `onActivated` also fires right after the first mount; the guard keeps that
  // from registering a second time.
  onActivated(() => {
    unregister ??= loadingState.register();
  });
  onDeactivated(leave);
  onBeforeUnmount(leave);
}
